import 'promise-polyfill/src/polyfill';
import $ from 'jquery';
import 'foundation-sites/js/foundation.core.js';
import { Accordion } from 'foundation-sites/js/foundation.accordion.js';
import { Reveal } from 'foundation-sites/js/foundation.reveal.js';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip.js';
import { Tabs } from 'foundation-sites/js/foundation.tabs.js';
import { Toggler } from 'foundation-sites/js/foundation.toggler.js';
import { Equalizer } from 'foundation-sites/js/foundation.equalizer.js';
import FoundationValidators from 'controller/foundationValidators';
import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu.js';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers.js';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js';
import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle.js';
import { Motion } from 'foundation-sites/js/foundation.util.motion.js';
import { Sticky } from 'foundation-sites/js/foundation.sticky.js';
import LazySizesConfig from "./controller/lazySizesConfig";
import LazySizes from 'lazysizes';
import 'stacktable.js';
import FooterLinks from 'controller/footerLinks';
import NewsLetterSignUp from 'controller/newsletterSignUp';
import TogglePanel from 'frontendController/togglePanel';
import AddToBasket from 'controller/addToBasket';
import DeferredImage from 'controller/deferredImage';
import SelectToggle from 'controller/selectToggle';
import USPBannerBar from 'controller/USPBannerBar/USPBannerBar';
import NavigationInit from 'frontendController/siteNavigation';
import './fontAwesome';
import Algolia from "controller/algolia/algolia";

function getView(name, params)
{
    import('view/' + name).then((Module) => {
        let module = new Module.default(params);
        module.init();
    }).catch(err => {
        console.error('View name: ' + name);
        console.error(err);
    });
}

function loadViews()
{
    const views = window.oflWebpackViews;
    delete window.oflWebpackViews;

    for (let i = 0; i < views.length; i++) {
        getView(views[i].name, views[i].params);
    }
}

function skinInit()
{
    const params = window.oflWebpackParams;
    delete window.oflWebpackParams;

    // Must be called before $(document).foundation();
    Foundation.addToJquery($);
    Foundation.plugin(Accordion, 'Accordion');
    Foundation.plugin(Reveal, 'Reveal');
    Foundation.plugin(Tooltip, 'Tooltip');
    Foundation.plugin(Tabs, 'Tabs');
    Foundation.plugin(Toggler, 'Toggler');
    Foundation.plugin(Equalizer, 'Equalizer');
    Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');
    Foundation.plugin(Triggers, 'Triggers');
    Foundation.plugin(MediaQuery, 'MediaQuery');
    Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');
    Foundation.plugin(Motion, 'Motion');
    Foundation.plugin(Sticky, 'Sticky');

    FoundationValidators.addCustomerValidators();

    new LazySizesConfig();
    LazySizes.init();

    $(document).ready(() => {
        $(document).foundation();
        $('.stacked').stacktable();
    });

    (new Algolia(
        params.algoliaApiId,
        params.algoliaApiSearchKey,
        params.algoliaIndex,
        params.algoliaUserSessionToken,
        params.algoliaUserAccountToken,
        params.algoliaSuggestionsIndex,
        params.algoliaTrackingEnabled,
        params.algoliaTrackingCookieName,
        params.algoliaDebounceMS
    )).setup();

    let navigationInit = new NavigationInit();
    navigationInit.init();

    let uspBannerBar = new USPBannerBar();
    uspBannerBar.init();

    let footerLinks = new FooterLinks();
    footerLinks.init();

    let newsletterSignUp = new NewsLetterSignUp();
    newsletterSignUp.init();

    let togglePanel = new TogglePanel();
    togglePanel.init();

    let addToBasket = new AddToBasket({
        addToBasketPopupProduct: params.addToBasketPopupProduct,
        addingItemToBasketText: params.addingItemToBasketText,
        addToBasketTrigger: params.addToBasketTrigger
    });
    addToBasket.init();

    let selectToggle = new SelectToggle();
    selectToggle.init();

    let deferredImage = new DeferredImage();
    deferredImage.init();
}

skinInit();
loadViews();